<div class="bg-grey-500 py-24 lg:pb-56">
    <div class="inner-page-wrapper">
        <div class="flex flex-col items-center justify-center gap-12 lg:flex-row lg:gap-[104px] lg:pt-24">
            @if (data().length > 0) {
                <div
                    class="xs:gap-16 flex w-full flex-col gap-[12px] overflow-x-auto overflow-y-hidden lg:w-max lg:flex-row lg:gap-32"
                >
                    @for (item of data(); track $index; let last = $last) {
                        <div
                            class="flex flex-1 flex-col justify-center sm:flex-[initial]"
                            [class.items-center]="item.link && item.linkText"
                        >
                            <div>
                                @let label = item.label | footnotes;
                                <span class="text-16 leading-27 text-black" [innerHTML]="label()"></span>
                                <div class="mt-2 flex items-end gap-4 text-black">
                                    @if (item.value && item.unit) {
                                        <span
                                            class="font-headline text-31 lg:text-50 leading-36 font-medium text-nowrap lg:leading-58"
                                        >
                                            {{ item.value }}
                                        </span>
                                        @let unitWithFootnote = item.unit | footnotes;
                                        <span
                                            class="font-headline text-14 lg:text-20 mb-5 leading-12 font-medium lg:leading-30"
                                            [innerHTML]="unitWithFootnote()"
                                        ></span>
                                    }
                                </div>
                                @if (item.link && item.linkText) {
                                    <a
                                        ui-m010-c020-icon-link
                                        class="mt-4 inline-block"
                                        [hyundaiRouterLink]="item.link"
                                        [queryParams]="item.linkQueryParams"
                                    >
                                        {{ item.linkText }}
                                    </a>
                                }
                            </div>
                        </div>
                        @if (!last) {
                            <div class="bg-grey-300 my-8 h-1 w-full shrink-0 lg:h-auto lg:w-1"></div>
                        }
                    }
                </div>
            }

            <div class="flex w-full flex-col gap-16 lg:w-auto">
                <a
                    class="button-primary"
                    [hyundaiRouterLink]="primaryButton()"
                    [trackingElTarget]="primaryButton()"
                    tracking
                    trackingElLabel="Test Drive"
                    trackingEvent="engagement_click"
                    trackingElType="button"
                >
                    {{ primaryButtonText() }}
                </a>
            </div>
        </div>
        @if (envkv(); as data) {
            @let envkvWithFootnote = data | footnotes;
            <span class="mt-12 block md:mt-40" [innerHTML]="envkvWithFootnote()"></span>
        }
    </div>
</div>
